'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadVideos = exports.loadVideo = exports.classes = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _functional = require('./functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = exports.classes = {
  LOADER: 'lazyload-video',
  LOADED: 'lazyloaded'
};

var loadVideo = exports.loadVideo = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(video) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var loadingClass, sources;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!video.lazyloaded) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return');

          case 2:
            loadingClass = options.loadingClass || classes.LOADER;
            sources = (0, _functional.getElements)('source', { context: video });

            sources.map(function (source) {
              source.src = source.dataset.src;
            });

            video.load();

            _context.prev = 6;
            _context.next = 9;
            return video.play();

          case 9:
            video.classList.remove(loadingClass);
            video.classList.add(classes.LOADED);
            video.lazyloaded = true;
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](6);

            console.warn(_context.t0);

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[6, 14]]);
  }));

  return function loadVideo(_x) {
    return _ref.apply(this, arguments);
  };
}();

var loadVideos = exports.loadVideos = function loadVideos(selector, context) {
  var loadingClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : classes.LOADER;

  var videos = (0, _functional.getElements)(selector, { context: context });

  videos.forEach(function (video) {
    loadVideo(video, { loadingClass: loadingClass });
  });
};